import React from "react";

import { Box, Container, Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import clsx from "clsx";
import { useTranslation } from "react-i18next";

import config from "config";
const useStyles = makeStyles(theme => {
	return {
		root: {
			display: "flex",
			flexDirection: "column",
			padding: 0,
			// paddingTop: theme.spacing(2),
			marginTop: theme.spacing(1)
		},
		titleRow: {
			marginBottom: theme.spacing(1),
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between"
		},
		titleBlock: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between"
		},
		termsText: {
			fontSize: 12,
			textTransform: "uppercase",
			fontWeight: 500,
			color: "#fff",
			[theme.breakpoints.up(480)]: {
				color: theme.palette.text.primary,
				fontSize: 14,
				fontWeight: 500
			}
		},
		linkText: {
			color: theme.palette.primary.light
		}
	};
});

interface TermsProps {
	props?: any;
	className?: string;
}

const Terms: React.FC<TermsProps> = ({ className }: TermsProps) => {
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<Container className={clsx(className, classes.root)}>
			<Box className={classes.titleRow}>
				<Box className={classes.titleBlock}>
					<Typography className={classes.termsText}>
						{t("consentText")}{" "}
						<Link href={config.privacyPolicyUrl} target="_blank" className={classes.linkText}>
							{t("privacyPolicy")}
						</Link>{" "}
						{t("and")}{" "}
						<Link href={config.termsUrl} target="_blank" className={classes.linkText}>
							{t("termsOfService")}
						</Link>
					</Typography>
				</Box>
			</Box>
		</Container>
	);
};

export default Terms;
